export const environment = {
  env: 'prod',
  production: true,
  maintenance: false,
  url_site: 'https://apps.calia.ai/',
  url_api: 'https://api.calia.ai/api/',
  title: 'Prod Environment',
  i18nFolder: 'assets/i18n/',
  superAdmins: ['admin@calia.com.co', 'alejandro.roman@calia.ai'],
};
